import { useState } from "react";
import { CoalitionSection } from "../CoalitionSection";
import { CoalitionModal } from "..//CoalitionModal";
import { CoalitionCardRewards } from "../CoalitionCardRewards";
import { CoalitionCardRewardsDetail } from "..";
import { empty_rewards } from "../../pngs";
import { EmptyBlock } from "./EmptyBlock";
import { sendTag, event_properties_101_04 } from "../CoalitionGtm";
import {
  rewardsLabel,
  privGtmKey,
  toggleScrollLock,
  getCardDetail,
} from "../../utils";

export const RewardsBlock = ({ rewards }) => {
  const [modal, setModal] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const gtm = localStorage.getItem(privGtmKey);

  const toggleModal = (cardId = null) => {
    setIsShown(Boolean(cardId));
    toggleScrollLock();
    setActiveCard(getCardDetail(rewards, cardId));
  };
  const showModalFn = (cardId, i) => {
    toggleModal(cardId);
    if (gtm) {
      let payload = event_properties_101_04();
      payload.reward_id = i.id;
      payload.reward_progress = rewardsLabel(i);
      payload.banner_index = i.position;
      sendTag(gtm, payload);
    }
  };

  const title = "Obtén recompensas";
  const emptyDesc =
    "Muy pronto podrás llevarte productos de regalo al sumar tus compras";
  const filledDesc =
    "Llévate productos de regalo al sumar tus compras y llegar a la meta";
  const modalTitle = "Todo sobre tus recompensas";

  return (
    <>
      {!rewards || rewards.length === 0 ? (
        <EmptyBlock
          title={title}
          description={emptyDesc}
          emptyState={empty_rewards}
          isBlock={true}
        />
      ) : (
        <>
          <CoalitionSection title={title} subtitle={filledDesc}>
            {rewards.map((i, k) => (
              <CoalitionCardRewards
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                used={i.balance}
                needed={i.required_balance}
                availableToRedeem={i.available_to_redeem}
                showModal={(cardId) => showModalFn(cardId, i)}
              />
            ))}
          </CoalitionSection>
          {isShown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={modalTitle}
            >
              <CoalitionCardRewardsDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
